import React from 'react';
import { Modal, Tooltip, Icon, Button, Row, Col, Spin } from 'antd';
import { StylesProps } from 'src/Library/Types';
import Form, { FormComponentProps } from 'antd/lib/form';
import { DiscoverRatesSearchBarStyles } from './DiscoverRatesSearchBar.styles';
import withStyles from 'react-jss';
import DiscoverRatesServicesFilterDetails from './DiscoverRatesServicesFilterDetails';
import { SEConsignorAddress } from '../shipment-execution/SE.interfaces';
import isEmpty from 'lodash/isEmpty';

interface IProps extends FormComponentProps, StylesProps<ReturnType<typeof DiscoverRatesSearchBarStyles>> {
  isVisible: boolean;
  handleClose: (serviceDetails?) => void;
  stuffingAddresses: SEConsignorAddress[];
  deStuffingAddresses: SEConsignorAddress[];
  isFetchingAddresses?: boolean;
  services: {
    [location: string]: {
      key: string;
      serviceType: string;
      type: string[];
    }
  };
  searchFilters: string;
  mode: string;
}

const DiscoverRatesServicesFilterDetailsModal = (props: IProps) : React.ReactElement => {

  const {
    isVisible,
    classes,
    handleClose,
    form,
    isFetchingAddresses,
    stuffingAddresses,
    deStuffingAddresses,
    services,
    mode,
  } = props;

  const handleSubmit = () => {
    form.validateFields((err, values) => {
      if (err) return;
      let serviceTypes = {};
      Object.keys(services || {}).forEach((service: string) => {
        const { key, type } = services[service];
        serviceTypes = {
          ...serviceTypes,
          [key]: [...type],
        }
      });
      
      const { stuffingType, stuffingLocationId, destuffingType, destuffingLocationId } = values
      let stuffingWeight, destuffingWeight;
      if (values.stuffingWeight) {
        stuffingWeight = { unit: values.stuffingUnit, value: values.stuffingWeight };
      }
      if (values.destuffingWeight) {
        destuffingWeight = { unit: values.destuffingUnit, value: values.destuffingWeight };
      };

      handleClose({
        ...serviceTypes, 
        ...(stuffingType && { stuffingType }), ...(stuffingLocationId && {stuffingLocationId}), 
        ...(destuffingType && { destuffingType }), ...(destuffingLocationId && {destuffingLocationId}), 
        ...(stuffingWeight && { stuffingWeight }), ...(destuffingWeight && {destuffingWeight})
      });
    });
  }

  const renderFooter = () : React.ReactElement => {
    return (
      <React.Fragment>
        <span onClick={() => handleClose({})}>
          <span className={classes.skipNowButton}>Skip Now</span>
          <Tooltip title="Skip to view only freight &amp; local charges" overlayStyle={{ fontSize: '10px' }}>
            <Icon
              type="info-circle"
              theme="filled"
            />
          </Tooltip>
        </span>
        <Button className={classes.confirmButton} onClick={handleSubmit}>Confirm</Button>
      </React.Fragment>
    );
  };

  const renderServicesFilterDetails = (service) : React.ReactElement => {
    return (
      <DiscoverRatesServicesFilterDetails
        service={service}
        form={form}
        stuffingAddresses={stuffingAddresses}
        deStuffingAddresses={deStuffingAddresses}
        isFromSearchBar={true}
        mode={mode}
      />
    );
  };

  const renderDetails =  () : React.ReactElement => {
    return (
      <Row>
        {!isEmpty(services?.origin) &&
          <Col
            span={isEmpty(services?.destination) ? 24 : 13}
            style={{ paddingRight: '40px' }}
          >
            <div className={classes.stuffingDestuffingType}>Origin</div>
            {renderServicesFilterDetails(services?.origin)}
          </Col>
        }
        {!isEmpty(services?.destination) &&
          <Col
            span={isEmpty(services?.origin) ? 24 : 11}
          >
            <div className={classes.stuffingDestuffingType}>Destination</div>
            {renderServicesFilterDetails(services?.destination)}
          </Col>
        }
      </Row>
    );
  };

  return (
    <Modal
      visible={isVisible}
      width={(!isEmpty(services?.origin) && !isEmpty(services?.destination)) ? 750 : 400}
      title="Details"
      footer={renderFooter()}
      onCancel={() => handleClose({})}
    >
      {isFetchingAddresses ? <Spin style={{ marginLeft: '48%' }} /> : renderDetails()}
    </Modal>
  )
}

export default React.memo(
  withStyles(DiscoverRatesSearchBarStyles)
  (Form.create()(DiscoverRatesServicesFilterDetailsModal))
);